import { AnyAction } from "@reduxjs/toolkit";
import { FilterFunction } from "redux-undo";

export const сompareFilter: FilterFunction<any, AnyAction> = (
  _,
  currentState,
  previousHistory
) => {
  return currentState.version !== previousHistory?.present?.version;
};
